import React from 'react';
import './_restricted.scss';

export const Restricted = () => {
  return <div className="restricted__container">You don't have access to this application...</div>;
};
